/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Usersettings_WriteInputs */

const en_enum_permission_name_usersettings_write = /** @type {(inputs: Enum_Permission_Name_Usersettings_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Usersettings Write`)
};

const de_enum_permission_name_usersettings_write = /** @type {(inputs: Enum_Permission_Name_Usersettings_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Usersettings Write`)
};

/**
* | output |
* | --- |
* | "Name Usersettings Write" |
*
* @param {Enum_Permission_Name_Usersettings_WriteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_usersettings_write = /** @type {((inputs?: Enum_Permission_Name_Usersettings_WriteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Usersettings_WriteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_usersettings_write(inputs)
	return de_enum_permission_name_usersettings_write(inputs)
});